export function getSymbilityUrl(claimNumber: string, isProdEnv: boolean) {
  const prefix = isProdEnv ? 'www' : 'staging'
  return `https://${prefix}.symbility.net/ux/site/?lang=en-US#/claims;quickSearch=${claimNumber}`
}
